function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.875 3.5H6.125C3.5 3.5 1.75 5.25 1.75 7.875V13.125C1.75 15.75 3.5 17.5 6.125 17.5H14.875C17.5 17.5 19.25 15.75 19.25 13.125V7.875C19.25 5.25 17.5 3.5 14.875 3.5ZM12.1538 11.4012L9.99248 12.6963C9.11748 13.2213 8.39998 12.8188 8.39998 11.795V9.19626C8.39998 8.17251 9.11748 7.77001 9.99248 8.29501L12.1538 9.58999C12.985 10.0975 12.985 10.9025 12.1538 11.4012Z",
    fill: "#FF5151",
    style: {
      fill: "#FF5151",
      fill: "color(display-p3 1.0000 0.3167 0.3167)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.824d9a183cc0b559f26f3261ebf0d774.svg";
export { ForwardRef as ReactComponent };